import { ColumnTypeEnum } from '~components/dynamic-table/models/enums/column-type.enum';
import { TextAlignmentEnum } from '~core/models/enums/text-alignment.enum';
import { IconModel } from '~core/models/icon.model';
import { BaseColumnModel } from './base-column.model';

export class IconColumnModel extends BaseColumnModel {
    iconMapping!: Map<any, IconModel>;
    override columnTitleAlignment = TextAlignmentEnum.Center;

    constructor(init?: Partial<IconColumnModel>) {
        super(ColumnTypeEnum.Icon);

        if (!!init) {
            Object.assign(this, init);
        }
    }
}
